import { gql } from '@apollo/client';

const GET_PURCHASE_FLOW_CONFIGURATION = gql`
  query purchaseFlowConfiguration {
    purchaseFlowConfiguration {
      analyticsApiKey
      concessionaireId
      concessionaireName
      successUrl
      failureUrl
      financingConfiguration {
        enabled
        config {
          selected
          name
          ... on Forum {
            UpdateUser
            PartnerId
          }
          ... on MundoCredito {
            c_id
            a_Clave
          }
        }
      }
      insuranceConfiguration {
        enabled
        config {
          dealerId
          name
        }
      }
      extraItemsConfiguration {
        enabled
      }
      proceduresConfiguration {
        greenTax
        civilRegistration
        circulationPermit
        obligatoryInsurance
        tag
        prohibitionOfAlienating
      }
    }
  }
`;

const GET_CONCESSIONAIRE_STYLE = gql`
  query concessionaireStyle {
    concessionaireStyle {
      primaryColor
      concessionaireLogoUrl
      concessionaireIsoLogoUrl
    }
  }
`;

const configurationOperations = {
  GET_PURCHASE_FLOW_CONFIGURATION,
  GET_CONCESSIONAIRE_STYLE,
};

export default configurationOperations;
